import React from 'react';
import {
  Box,
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  VStack,
} from '@chakra-ui/react';
import { Formik, Field, Form } from 'formik';
import * as Yup from 'yup';
import { addGroup } from '../../store/api_funcs';
import { useStores } from '../../store/store_context';

const GroupSchema = Yup.object().shape({
  group_name: Yup.string().required('Введите название группы'),
  description: Yup.string().required('Введите описание группы'),
});

const GroupForm = ({ updatePanelsTable, updateGroups }) => {
  const { pageStore } = useStores();
  const handleSubmit = async (values, actions) => {
    await addGroup(values, pageStore.user_id, pageStore.token);
    await updateGroups()
    updatePanelsTable();
    console.log('Отправленные данные:', values);
    actions.setSubmitting(false);
  };

  return (
    <VStack width={'100%'} align={'flex-start'}>
      <Formik
        initialValues={{ group_name: '', description: '' }}
        validationSchema={GroupSchema}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting }) => (
          <Form style={{ width: '100%' }}>
            <Field name="group_name">
              {({ field, form }) => (
                <FormControl
                  isInvalid={form.errors.group_name && form.touched.group_name}
                >
                  <FormLabel htmlFor="group_name" width={'100%'}>
                    Название группы
                  </FormLabel>
                  <Input
                    {...field}
                    id="group_name"
                    placeholder="Введите название группы"
                    width={'100%'}
                    marginTop={'8px'}
                  />
                  <FormErrorMessage>{form.errors.group_name}</FormErrorMessage>
                </FormControl>
              )}
            </Field>
            <Field name="description">
              {({ field, form }) => (
                <FormControl
                  isInvalid={
                    form.errors.description && form.touched.description
                  }
                >
                  <FormLabel htmlFor="description" width={'100%'}>
                    Описание группы
                  </FormLabel>
                  <Input
                    {...field}
                    id="description"
                    placeholder="Введите описание группы"
                    width={'100%'}
                    marginTop={'8px'}
                  />
                  <FormErrorMessage>{form.errors.description}</FormErrorMessage>
                </FormControl>
              )}
            </Field>
            <Box mt={4}>
              <Button
                type="submit"
                isLoading={isSubmitting}
                backgroundColor={'#7B79FF'}
                _hover={{ backgroundColor: '#4945FF' }}
                color="white"
              >
                Создать группу
              </Button>
            </Box>
          </Form>
        )}
      </Formik>
    </VStack>
  );
};

export default GroupForm;
